/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Walkthrough_Admin_Billing_TitleInputs */

const es_walkthrough_admin_billing_title = /** @type {(inputs: Walkthrough_Admin_Billing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Facturación`)
};

const en_walkthrough_admin_billing_title = /** @type {(inputs: Walkthrough_Admin_Billing_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Billing`)
};

/**
* | output |
* | --- |
* | "Billing" |
*
* @param {Walkthrough_Admin_Billing_TitleInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const walkthrough_admin_billing_title = /** @type {((inputs?: Walkthrough_Admin_Billing_TitleInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Walkthrough_Admin_Billing_TitleInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_walkthrough_admin_billing_title(inputs)
	return en_walkthrough_admin_billing_title(inputs)
});
export { walkthrough_admin_billing_title as "walkthrough.admin_billing_title" }